import htmlComponents from './html';
import Renderer from './Renderer.svelte';
import Text from './Text.svelte';
export const defaultComponents = {
    ...htmlComponents,
    text: Text,
    raw: Text
};
export default Renderer;
